'use strict';
module.exports = require('./components/config/PrimeVue.js');